import { createContext } from "react";

export type UserSettings = {
  initialized: boolean,
  saveSetting?: (key: string, value: object) => void
  settings: { [key: string]: any, }
}

export const defaultUserSettings = {
  initialized: false,
  saveSetting: undefined,
  settings: {},
};

Object.freeze(defaultUserSettings);

export const UserSettingContext = createContext<UserSettings>(defaultUserSettings);

export default UserSettingContext;
